import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const sentence = [
  "We are an",
  "open-source-first",
  "applied AI research",
  "&",
  "engineering lab",
  "—",
  "building intelligence",
  "that thinks,",
  "speaks &",
  "acts.",
];

function Word({ word, progress, range }) {
  const opacity = useTransform(progress, range, [0.12, 1]);
  const y = useTransform(progress, range, [12, 0]);
  return (
    <motion.span
      style={{ opacity, y }}
      className="inline-block mr-[0.3em]"
    >
      {word}
    </motion.span>
  );
}

export default function AboutSection() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start 0.85", "end 0.4"],
  });

  return (
    <section
      ref={ref}
      id="about"
      data-testid="about-section"
      className="relative min-h-[160vh] w-full"
    >
      <div className="sticky top-0 h-screen flex items-center">
        <div className="w-full max-w-screen-2xl mx-auto px-6 md:px-12 xl:px-24">
          <div className="grid grid-cols-12 gap-6 mb-16 items-baseline">
            <div className="col-span-12 md:col-span-3 flex items-center gap-3">
              <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#d4ff00]">
                /01
              </span>
              <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#8a8a8a]">
                Identity
              </span>
            </div>
          </div>

          <h2
            className="font-display leading-[1.02] tracking-tight text-[#fafafa] max-w-6xl"
            style={{ fontSize: "clamp(1.6rem, 4.8vw, 4.8rem)" }}
            data-testid="about-headline"
          >
            {sentence.map((w, i) => {
              const start = i / sentence.length;
              const end = start + 1 / sentence.length;
              return (
                <Word
                  key={i}
                  word={w}
                  progress={scrollYProgress}
                  range={[start, end]}
                />
              );
            })}
          </h2>

          <div className="mt-16 md:mt-24 grid grid-cols-12 gap-6 border-t border-white/10 pt-8">
            <div className="col-span-12 md:col-span-4">
              <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#8a8a8a]">
                Founded
              </span>
              <p className="mt-2 font-display text-3xl md:text-4xl text-white">
                2025 / IN
              </p>
            </div>
            <div className="col-span-6 md:col-span-4">
              <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#8a8a8a]">
                Discipline
              </span>
              <p className="mt-2 font-body text-sm md:text-base text-white leading-relaxed">
                Research · Engineering · Deployment
              </p>
            </div>
            <div className="col-span-6 md:col-span-4">
              <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#8a8a8a]">
                Posture
              </span>
              <p className="mt-2 font-body text-sm md:text-base text-white leading-relaxed">
                Sovereign · Open · Deployable
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
